import { createApp } from "vue";
import App from "./App.vue";
import Vueform from '@vueform/vueform'
import vueformConfig from './vueform.config'
import router from "./router";
import store from "./store";
import './echo';
import { createPinia } from 'pinia'
import { vSafeHtml } from '@/directives/safeHtml';
import * as Sentry from "@sentry/vue";
import { sentryBeforeSend } from "@/utils/sentryFilters";

const pinia = createPinia()
const app = createApp(App);

if (import.meta.env.PROD) {
  Sentry.init({
    app,
    dsn: "https://1e3a147a23118b1337f06a513891e5e0@o4511362086928384.ingest.us.sentry.io/4511362144862208",
    sendDefaultPii: true,
    beforeSend: sentryBeforeSend,
  });
}

// bootstrap
import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;

// modals
import "./assets/sass/components/custom-modal.scss";

// perfect scrollbar
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import 'vue3-perfect-scrollbar/style.css';
//vue-meta
import { createHead } from "@vueuse/head";
const head = createHead();

//Sweetalert
import Swal from "sweetalert2";
window.Swal = Swal;

// nouislider - later remove and add to page due to not working in page
import VueNouislider from "vue3-nouislider";
import "vue3-nouislider/dist/vue3-nouislider.css";

// vue input mask
import Maska from "maska";

// smooth scroll
import { registerScrollSpy } from "vue3-scroll-spy/dist/index";
registerScrollSpy(app, { offset: 118 });

//vue-i18n
import i18n from "./i18n";

// datatables
import {ServerTable, ClientTable, EventBus} from 'v-tables-3';

// json to excel
import vue3JsonExcel from "vue3-json-excel";

//vue-wizard
import VueFormWizard from "vue3-form-wizard";
import "vue3-form-wizard/dist/style.css";

// set default settings
import appSetting from "./app-setting";
window.$appSetting = appSetting;
window.$appSetting.init();

//markdown editor
import VueEasymde from 'vue3-easymde';
import "easymde/dist/easymde.min.css";

app
.use(Vueform, vueformConfig)
.use(store)
.use(pinia)
.use(router)
.use(i18n)
.use(PerfectScrollbarPlugin)
.use(VueNouislider)
.use(Maska)
.use(ClientTable)
.use(ServerTable)
.use(vue3JsonExcel)
.use(VueFormWizard)
.use(head)
.use(VueEasymde)
.directive('safe-html', vSafeHtml)
.mount("#app");

// Hidrata sessão após a primeira navegação (evita corrida com o overlay ao abrir termos/privacidade em nova aba).
if (typeof localStorage !== 'undefined' && localStorage.getItem('auth_token')) {
  router.isReady().then(() => {
    store.dispatch('auth/checkAuth');
  });
}
